"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deleteExportedFileMock;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
function deleteExportedFileMock(_ref) {
  var resolve = _ref.resolve;
  setTimeout(function () {
    resolve();
  }, 500);
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(deleteExportedFileMock, "deleteExportedFileMock", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/mock/delete-exported-file.mock.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJkZWxldGVFeHBvcnRlZEZpbGVNb2NrIiwicmVzb2x2ZSIsInNldFRpbWVvdXQiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2VydmljZXMvbW9jay9kZWxldGUtZXhwb3J0ZWQtZmlsZS5tb2NrLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGRlbGV0ZUV4cG9ydGVkRmlsZU1vY2soeyByZXNvbHZlIH0pIHtcblx0c2V0VGltZW91dCgoKSA9PiB7XG5cdFx0cmVzb2x2ZSgpO1xuXHR9LCA1MDApO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQWUsU0FBU0Esc0JBQXNCLE9BQWM7RUFBQSxJQUFYQyxPQUFPLFFBQVBBLE9BQU87RUFDdkRDLFVBQVUsQ0FBQyxZQUFNO0lBQ2hCRCxPQUFPLEVBQUU7RUFDVixDQUFDLEVBQUUsR0FBRyxDQUFDO0FBQ1I7QUFBQztBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQSx3QkFKdUJELHNCQUFzQjtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9